module.exports = __webpack_public_path__ + "media/images/UK-groom-image1-fd4dd88c48f5cde50ff660277e24f2b6.jpg";